import React, { useState, useEffect } from "react";
import { Formik, Form, Field, FieldArray, FastField, useFormik } from "formik";
import Select from "react-select";
import csc from "country-state-city";

export const CompanySetting = () => {
  const initialValues = {
    name: "",
    post_code: "",
    street_name: "",
    door_number: "",
    country: "",
    state: "",
    city: "",
    phone_number: "",
    website: "",
    contact: [],
  };
  const addressFromik = useFormik({
    initialValues: {
      country: null,
      state: null,
      city: null,
    },
    onSubmit: (values) => console.log(JSON.stringify(values.country)),
  });

  const countries = csc.getAllCountries();

  const updatedCountries = countries.map((country) => ({
    label: country.name,
    value: country.isoCode,
    ...country,
  }));
  const updatedStates = (countryId) =>
    csc.getStatesOfCountry(countryId).map((state) => ({
      label: state.name,
      value: state.countryCode,
      ...state,
    }));

  const updatedCities = (countryId) =>
    csc.getCitiesOfCountry(countryId).map((city) => ({
      label: city.name,
      value: city.stateCode,
      // lat: city.latitude,
      // long: city.longitude,
      ...city,
    }));

  const [Country, setCountry] = useState<any>({});
  const [State, setState] = useState<any>({});
  const [City, setCity] = useState<any>({});

  const { values, handleSubmit, setFieldValue, setValues } = addressFromik;
  useEffect(() => {}, [values]);

  const onSubmit = (values, onSubmitProps) => {
    let payload = {
      name: values.name,
      post_code: values.post_code,
      street_name: values.street_name,
      door_number: values.door_number,
      country: Country?.label,
      state: State?.label,
      city: City,
      phone_number: values.phone_number,
      website: values.website,
      contact: values.contact,
    };
    console.log("Customer", payload);
    // getAuthorization()
    //   .post("company/add_customer/", payload)
    //   .then((res) => {
    //     onSubmitProps.setSubmitting(false);
    //     Swal.fire({
    //       position: "top-end",
    //       title: "Customer Added!",
    //       showConfirmButton: false,
    //       timer: 3500,
    //       showClass: {
    //         popup: "animate__animated animate__fadeInRight",
    //       },
    //       hideClass: {
    //         popup: "animate__animated animate__fadeOutRight",
    //       },
    //       width: 300,
    //       color: "#FFFFFF",
    //       background: "#2A91D7",
    //       backdrop: `rgba(0,0,0,0)`,
    //     });
    //     getCustomerTabledata();
    //     Navigate("/dashboard/management/customer-dashboard");
    //   })
    //   .catch((err) => {
    //     console.log("Error", err);
    //     onSubmitProps.setSubmitting(false);
    //   });
  };
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };

  const PremiumPlan = [
    {
      title: "Workforce instructions scheduling",
    },
    {
      title: "Managment of workforce training",
    },
    {
      title: "Training",
    },
    {
      title: "Quality control",
    },
    {
      title: "Bill of materials",
    },
    {
      title: "Tracking",
    },
    {
      title: "Chat support",
    },
    {
      title: "Plan of action provided",
    },
  ];
  const PremiumPlanItems = [
    {
      title: "Selected Plan",
      type:"Premium",
    },
    {
      title: "Users",
      type:"50",
    },
    {
      title: "Before VAT",
      type:"₤680",
    },
    {
      title: "Current Price",
      type:"₤850",
    },
    {
      title: "Payement Interval",
      type:"Per month",
    },
    
  ];
  const WarehousePlan = [
    {
      title: "Track items inside the warehouse",
    },
    {
      title: "Separate items by quality",
    },
    {
      title: "Perform stock take",
    },
    {
      title: "Able to design warehouse",
    },
    {
      title: "Manage warehouse goods in and out",
    },
    
  ];
  return (
    <div>
      <div className="flex justify-center">
        <select
          className="form-select appearance-none
            block
            w-1/4
            px-4
            py-3
            text-sm
            font-Montserrat
            text-gray-700
            bg-white bg-clip-padding bg-no-repeat
            border border-solid border-gray-100
            rounded-lg
            transition
            ease-in-out
            m-0
            focus:text-gray-700 focus:border-blue-100 focus:outline-none"
          aria-label="Default select example"
        >
          <option selected>The company name</option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div className="flex  font-Montserrat">
        <div className=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
        <p className="text-blue-200 font-Montserrat font-medium">
          Company details
        </p>
      </div>
      <div className="flex flex-wrap">
        <div className="flex-1 mt-7 ml-3">
          <div className="text-center">
            <img
              className="object-cover w-24 h-24 rounded-full m-auto"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=="
              alt="Avatar"
            />
          </div>
          <div className="text-gray-50 text-sm font-Montserrat mt-4 text-center">
            Add Company logo
          </div>
          <div className="text-gray-50 text-sm font-Montserrat mt-1 text-center">
            Change Logo
          </div>
        </div>
        <div className="flex-4">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            //   validationSchema={validationSchema}
            //   validateOnMount
          >
            <Form>
              <div className="mt-9 grid space-y-10">
                <Field name="name">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Company Name:"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="Last_name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Phone : "
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="post_code">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Website: "
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <Field name="street_name">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <textarea
                          {...field}
                          type="text"
                          rows={3}
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border bg-white rounded-lg relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border bg-white rounded-lg relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="About Company: "
                        ></textarea>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat  text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <Field name="door_number">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Address: "
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>

                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="country">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                          <Select
                            {...field}
                            id="country"
                            name="country"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "bg-default relative block w-full  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-full  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            options={updatedCountries}
                            value={values.country}
                            placeholder="Country"
                            onChange={(value) => {
                              // setValues(
                              //   { country: value, state: null, city: null },
                              //   false
                              // );
                              setFieldValue("country", value);
                              setCountry(value);
                              console.log("country value", value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="state">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                          <Select
                            {...field}
                            id="state"
                            name="state"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="State"
                            options={updatedStates(
                              values.country ? values.country.value : null
                            )}
                            value={values.state}
                            onChange={(value) => {
                              setValues({ state: value, city: null }, false);
                              setState(value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="city">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="City"
                        ></input> */}
                          <Select
                            {...field}
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    " bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            id="city"
                            name="city"
                            placeholder="City"
                            options={updatedCities(
                              values.state ? values.state.value : null
                            )}
                            value={values.city}
                            onChange={(value) => {
                              setFieldValue("city", value);
                              setCity(value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <Field name="website">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Postcode: "
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <div className="flex mt-8 font-Montserrat">
        <div className=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
        <p className="text-blue-200 font-Montserrat font-medium">
          Subscription Settings
        </p>
      </div>
      <p className="text-sm font-Montserrat pt-2 font-medium">
        Billing details remaining
      </p>
      <p className="text-sm font-Montserrat pt-2 font-medium">
        Warehouse management package should be ab it more of a unique add on
      </p>

      <div className="flex flex-wrap mt-16 ">
        <div className="flex-2  bg-white shadow-lg border-cyan-100 border-1 rounded-xl  pt-4 px-8 pb-8">
          <div className="text-black font-semibold text-lg font-Montserrat mt-4 text-center">
            Premium
          </div>
          <div className="text-black font-medium text-sm font-Montserrat mt-2 text-center">
            (min 50 user)
          </div>
          <div className="flex flex-wrap font-semibold text-xl font-Montserrat mt-4 text-center m-auto place-content-center">
            <div className="text-blue-200  ">$17</div>
            <div className="text-gray-50  ">/User</div>
          </div>
          {PremiumPlan.map((item, index) => (
            <div key={index} className="flex flex-wrap pt-2">
              <svg
                className="mr-4"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.33268 10.2917L9.51868 12.8405C9.9466 13.1828 10.5703 13.117 10.9173 12.6928L17.416 4.75"
                  stroke="#26F32E"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.34873 9.41774L12.6497 5.38327C12.9994 4.95582 12.9364 4.3258 12.5089 3.97607C12.0815 3.62635 11.4515 3.68935 11.1018 4.11679L7.81223 8.13732L9.34873 9.41774ZM6.18242 13.2877L4.64591 12.0073L4.5838 12.0832L2.18404 10.2834C1.74222 9.95199 1.11541 10.0415 0.784044 10.4834C0.452672 10.9252 0.542215 11.552 0.984043 11.8834L3.3838 13.6832C4.24118 14.3262 5.45305 14.1791 6.13171 13.3497L6.18242 13.2877Z"
                  fill="#26F32E"
                />
              </svg>
              <div>{item.title}</div>
            </div>
          ))}
          <button
            type="submit"
            className="text-white w-full justify-center mt-8 bg-green-100 hover:bg-green-200 font-Montserrat font-medium text-lg  rounded-md py-1 px-16 flex  "
          >
            Plan Selected
          </button>
          <button
            type="submit"
            className="text-blue-200 justify-center w-full mt-4 font-Montserrat font-medium text-lg  rounded-md py-1 px-16 flex "
          >
            Change Plan
          </button>
        </div>
        <div className="flex-4  ml-4 bg-white shadow-lg border-cyan-100 border-1 rounded-xl  pt-4 px-8 pb-8">
          <button
            type="submit"
            className="text-blue-200 justify-center float-right w-fit mt-4 font-Montserrat font-medium text-lg  rounded-md pb-1  flex "
          >
            Edit
            <svg
              className="ml-2"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.8335 10.0027C15.3726 10.0027 15.0002 10.3761 15.0002 10.836V17.5028C15.0002 17.962 14.6268 18.3361 14.1669 18.3361H2.50003C2.03997 18.3361 1.66674 17.962 1.66674 17.5028V5.83597C1.66674 5.37682 2.03997 5.00267 2.50003 5.00267H9.16683C9.62765 5.00267 10.0001 4.62929 10.0001 4.16938C10.0001 3.70932 9.62765 3.33594 9.16683 3.33594H2.50003C1.12169 3.33594 0 4.45762 0 5.83597V17.5028C0 18.8812 1.12169 20.0029 2.50003 20.0029H14.1669C15.5452 20.0029 16.6669 18.8812 16.6669 17.5028V10.836C16.6669 10.3752 16.2943 10.0027 15.8335 10.0027Z"
                fill="#1F78B4"
              />
              <path
                d="M7.81296 9.24184C7.75467 9.30013 7.71545 9.37429 7.69882 9.45424L7.10967 12.4011C7.08221 12.5376 7.12554 12.6785 7.22381 12.7776C7.303 12.8568 7.40966 12.8993 7.51892 12.8993C7.54547 12.8993 7.57309 12.8968 7.60055 12.891L10.5465 12.3019C10.6281 12.2851 10.7022 12.246 10.7598 12.1876L17.3532 5.59418L14.4073 2.64844L7.81296 9.24184Z"
                fill="#1F78B4"
              />
              <path
                d="M19.3882 0.609405C18.5758 -0.203135 17.2541 -0.203135 16.4423 0.609405L15.2891 1.76268L18.235 4.70857L19.3882 3.55515C19.7816 3.16269 19.9983 2.63931 19.9983 2.08266C19.9983 1.52601 19.7816 1.00263 19.3882 0.609405Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
          <div className="mt-16">
          {PremiumPlanItems.map((item, index) => (
          <div key={index} className="flex flex-wrap pt-3">
            <div className=" text-gray-50 font-Montserrat text-center w-1/3 place-content-center font-medium mr-4">
              {item.title}
            </div>
            <input
              type="text"
              className="border-1 rounded-lg  ml-4 relative block w-2/4 px-4 border-gray-200 placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors"
              placeholder={item.type}
            ></input>
          </div>
          ))}
          </div>

          <div className="font-Montserrat font-semibold py-4 w-fit cursor-pointer text-lg  text-blue-200">
          Warehouse Management package
        </div>
        <div className="flex flex-wrap">
            <div className="flex-2 self-center">
                <div className=" text-gray-50 text-lg text-center font-Montserrat font-medium">
                    Total
                </div>
                <div className="text-blue-200 text-xl text-center font-Montserrat font-bold">
                    $1000
                </div>
            </div>
            <div className="flex-4 border-1 border-gray-50 rounded-lg p-4">
          {WarehousePlan.map((item, index) => (

                <div key={index} className="text-gray-50 text-base pt-1">{item.title}</div>
                ))}
            </div>
</div>
        </div>
      </div>

      <div className="flex flex-row justify-center space-x-144 my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat font-medium text-lg"
          // onClick={() =>
          //   Navigate("/dashboard/management/customer-dashboard")
          // }
        >
          Go Back
        </button>
        <button
          type="submit"
          className="text-white bg-green-100 hover:bg-green-200 font-Montserrat font-medium text-lg place-content-center rounded-md py-1 px-16 flex flex-shrink-1 "
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};
